import React from "react";

import {
  CORESelect,
  CORESelectProps,
} from "../../COREDesignSystem/Form/CORESelect";
import { TestID } from "../../shared/testids/testids";

export type AuLocation = {
  id: number;
  name: string;
  shortName: string;
};

export const PriceHistoryLocationSelect: React.FC<
  {
    testID: TestID;
  } & CORESelectProps
> = ({ testID, onChange, ...props }) => {
  const options = [
    {
      label: "NSW",
      value: "NSW",
    },
    {
      label: "Qld",
      value: "Qld",
    },
    {
      label: "SA",
      value: "SA",
    },
    {
      label: "Vic",
      value: "Vic",
    },
  ];
  return (
    <CORESelect
      placeholder="Select location"
      testID={testID}
      onChange={onChange}
      options={options}
      {...props}
    />
  );
};
